import React from "react";
import {css} from "@emotion/react";

import {Text} from "@pg-design/text-module";

import {getEnergyPerformanceValues} from "../utils/energy_perfomance";

interface IProps {
    property: {
        co2_emission_unit: number | null;
        final_energy_indicator: number | null;
        primary_energy_indicator: number | null;
        renewable_energy_sources: number | null;
        usable_energy_indicator: number | null;
    };
}
export const PropertyDetailEnergyPerformance = (props: IProps) => {
    const energyPerformanceValues = getEnergyPerformanceValues(props.property);

    if (!energyPerformanceValues.length) {
        return (
            <Text variant="body_copy_2" as="div">
                informacja u dewelopera
            </Text>
        );
    }

    return (
        <ul>
            {energyPerformanceValues.map((energyPerformance) => {
                return (
                    <li key={energyPerformance.key}>
                        {energyPerformance.label}: <span css={keepWord} dangerouslySetInnerHTML={{__html: energyPerformance.value}} />
                    </li>
                );
            })}
        </ul>
    );
};

const keepWord = css`
    white-space: nowrap;
`;
import React from "react";
import {css} from "@emotion/react";

import {Text} from "@pg-design/text-module";

import {getEnergyPerformanceValues} from "../utils/energy_perfomance";

interface IProps {
    property: {
        co2_emission_unit: number | null;
        final_energy_indicator: number | null;
        primary_energy_indicator: number | null;
        renewable_energy_sources: number | null;
        usable_energy_indicator: number | null;
    };
}
export const PropertyDetailEnergyPerformance = (props: IProps) => {
    const energyPerformanceValues = getEnergyPerformanceValues(props.property);

    if (!energyPerformanceValues.length) {
        return (
            <Text variant="body_copy_2" as="div">
                informacja u dewelopera
            </Text>
        );
    }

    return (
        <ul>
            {energyPerformanceValues.map((energyPerformance) => {
                return (
                    <li key={energyPerformance.key}>
                        {energyPerformance.label}: <span css={keepWord} dangerouslySetInnerHTML={{__html: energyPerformance.value}} />
                    </li>
                );
            })}
        </ul>
    );
};

const keepWord = css`
    white-space: nowrap;
`;
